import React from 'react';
import { Navigate } from 'react-router-dom';
import { ERoutesCommon } from 'common/models/routesModel';

const RootPageComponent: React.FC = () => {
  return <Navigate to={ERoutesCommon.Main} replace />;
};

export const RootPage = RootPageComponent;
